// extracted by mini-css-extract-plugin
export default {"table":"style_table__wNN3I","tableCellHead":"style_tableCellHead__U3pVu","tableCell":"style_tableCell__vd5gJ"};